module.exports = __webpack_public_path__ + "static/media/24UHCHR25.183c759b.jpg";